/**
 * Wykrywa język przeglądarki i zwraca obsługiwany język lub fallback
 * Obsługiwane języki: pl, en, de, es, fr, it, cz, sk, no, se, ru, ua, gr
 */
export const detectBrowserLanguage = (): string => {
  const supportedLanguages = ['pl', 'en', 'de', 'es', 'fr', 'it', 'cz', 'sk', 'no', 'se', 'ru', 'ua', 'gr'];
  const fallbackLanguage = 'en';

  // Pobierz język z przeglądarki
  const browserLanguage = navigator.language || (navigator as any).userLanguage;

  if (!browserLanguage) {
    return fallbackLanguage;
  }

  // Wyciągnij kod języka (np. 'pl-PL' -> 'pl')
  const languageCode = browserLanguage.split('-')[0].toLowerCase();

  // Sprawdź czy język jest obsługiwany
  if (supportedLanguages.includes(languageCode)) {
    return languageCode;
  }

  // Zwróć fallback jeśli język nie jest obsługiwany
  return fallbackLanguage;
};
